import { general } from '@/services/api/ExpertoRetail'
import { getRootUsers } from '@/app/shared/services/rootUsersService'

export default {
  async fetchDesktopParameterConfig ({ commit }) {
    try {
      const response = await general.getDesktopParameterConfig()
      
      // Fetch root users for permission system
      try {
        const rootUsers = await getRootUsers()
        response.rootUsers = rootUsers
      } catch (rootUsersError) {
        console.warn('Could not fetch root users for permission system:', rootUsersError)
        response.rootUsers = []
      }
      
      commit('setDesktopParameterConfig', response)
    } catch (e) {
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/actions.js